<template>
    <div v-show="$root.countRequests > 0" class="vue-bg-spinner-loader">
        <div class="spinner-loader">
            <icon name="faSpinner" size="42" color="currentColor" pulse />
        </div>
    </div>
</template>

<script>
export default {
    name: "loader",
}
</script>

<style scoped>

</style>
